import React from 'react';
import { Noise, NoiseGrey, Tekstura } from './styles';

export const NoiseOverlay = ({ scene }) => <Noise scene={scene} />;
export const NoiseOverlayLight = ({ scene }) => <NoiseGrey scene={scene} />;
export const Texture = ({ scene }) => <Tekstura scene={scene} />;
